import _ from "lodash";
import {
  SERVICES,
  SERVICE_PROFILES,
  PROFILES,
} from "../../common/utils/permissions";
import {
  AccountActionTypes,
  CREATE_ACCOUNT_FAILURE,
  GET_ACCOUNT_SUCCESS,
  LOAD_ACCOUNT,
  UPDATE_WEB_FILTER_SUCCESS,
  GET_SPSON_SUCCESS,
} from "./account.types";
import {
  AccountData,
  BYPASS_PRIVATE_DNS,
  BypassPrivateDns,
} from "@sportal/api";
import { CHANGE_APR_SETTING_SUCCESS } from "../attributes/attributes.types";
import { withLoadingState } from "../shared";

export interface AccountState extends Omit<AccountData, "timezone"> {
  accountCreationFailed: boolean;
  isSpsonEnabled: boolean;
}

const initialState = {
  accountCreationFailed: false,
  isSpsonEnabled: false,
} as AccountState;

const accountReducer = (
  state: AccountState = initialState,
  action: AccountActionTypes
): AccountState => {
  switch (action.type) {
    case GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        ..._.omit(action.payload, "timezone"),
      };
    case UPDATE_WEB_FILTER_SUCCESS:
      return {
        ...state,
        [SERVICES.SB]: {
          ...state[SERVICES.SB],
          enabled: action.payload,
        },
      };
    case CHANGE_APR_SETTING_SUCCESS:
      const newByPassDNSConfig = {
        ...state[SERVICES.SB][BYPASS_PRIVATE_DNS],
        [BypassPrivateDns.ApplePrivateRelay]: action.payload,
      };

      return {
        ...state,
        [SERVICES.SB]: {
          ...state[SERVICES.SB],
          [BYPASS_PRIVATE_DNS]: newByPassDNSConfig,
        },
      };

    case CREATE_ACCOUNT_FAILURE:
      return {
        ...state,
        accountCreationFailed: true,
      };

    case GET_SPSON_SUCCESS: {
      return {
        ...state,
        isSpsonEnabled: true,
      };
    }
    default:
      return state;
  }
};

export default withLoadingState({
  loadActionType: LOAD_ACCOUNT,
  successActionType: GET_ACCOUNT_SUCCESS,
  failureActionType: CREATE_ACCOUNT_FAILURE,
})(accountReducer);

//TODO: actually service profiles do not always correspond to the types returns by /account (case of perdevice and per-device in PI)
//need to add type/service profile associations to the directory and rewrite the method
export const isSbMultiple = (account) =>
  account[SERVICES.SB] &&
  account[SERVICES.SB].type ===
    SERVICE_PROFILES[SERVICES.SB][PROFILES.MULTIPLE];
